import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Typography } from "@mui/material";

import APP_ROUTES from "../../../../routers/routeConstants";

import GinoHeader from "../../components/GinoHeader";
import { ArrowBackIcon } from "../../assets/icons/gino-icons";
import { useGetChatList } from "../../api/queries/useGetChatList";
import { useGetGinoCredits } from "../../api/queries/ginoCredits";

import { ChatRoomHistoryRow, ChatRoomHistoryRowLoader } from "./ChatRoomHistoryRow";

const GinoChatsHistoryListPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("gino", { keyPrefix: "chatHistoryPage" });

  const [openCreditLeftModal, setOpenCreditLeftModal] = useState(false);
  const handleOpenCreditLeftModal = () => setOpenCreditLeftModal(true);
  const handleCloseCreditLeftModal = () => setOpenCreditLeftModal(false);

  const { data: ginoCredits, isLoading: isLoadingGinoCredits, error: errorGinoCredits } = useGetGinoCredits();

  const { data: chatList, isLoading } = useGetChatList();
  return (
    <Box sx={styles.container}>
      <GinoHeader
        ginoCredits={ginoCredits}
        isLoadingGinoCredits={isLoadingGinoCredits}
        errorGinoCredits={errorGinoCredits}
        openCreditLeftModal={openCreditLeftModal}
        handleOpenCreditLeftModal={handleOpenCreditLeftModal}
        handleCloseCreditLeftModal={handleCloseCreditLeftModal}
        title={
          <Typography sx={styles.title}>
            <IconButton onClick={() => navigate(APP_ROUTES.GINO_CHAT)} sx={styles.backButton}>
              <ArrowBackIcon />
            </IconButton>
            {t("chatHistory")}
          </Typography>
        }
      />
      <Box sx={styles.chatRoomHistoryContainer}>
        {isLoading &&
          Array.from({ length: 5 }).map((_, index) => (
            <>
              <ChatRoomHistoryRowLoader key={index} />
              {index !== 4 && <Divider />}
            </>
          ))}
        {!isLoading && chatList && chatList.length === 0 && <Typography sx={styles.noChats}>{t("noChats")}</Typography>}
        {!isLoading &&
          chatList &&
          chatList.length > 0 &&
          chatList.map((chat, index) => {
            return (
              <>
                <ChatRoomHistoryRow key={chat.chatId} chat={chat} />
                {index !== chatList.length - 1 && <Divider />}
              </>
            );
          })}
      </Box>
    </Box>
  );
};

export default GinoChatsHistoryListPage;

const styles = {
  container: {
    width: "100%",
    height: "90vh",
    background: "var(--background-surface-default, #FFF)",
    padding: { xs: "16px", md: "32px" },
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflow: "hidden",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    fontFamily: "Montserrat",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  backButton: {
    padding: "0",
  },
  chatRoomHistoryContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
    overflow: "auto",
    paddingRight: "12px",
  },
  noChats: {
    color: "var(--black-100, #1C1C1C)",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    fontFamily: "Montserrat",
    textAlign: "center",
    pt: "24px",
  },
};
